import { parseRawBundleConfig } from './utils';
const defaultBundle = {
    cdnUrl: '',
    server: '',
    name: 'defaultBundle',
    paths: [],
    scripts: [],
    styles: [],
    stored: [],
};
/**
 * Возвращает экземпляр {@link MainBundleConfig}
 */
export function mainBundleConfig() {
    let mainBundle = typeof window !== 'undefined' && window.mainBundle;
    return parseRawBundleConfig(mainBundle || defaultBundle);
}
